import React, { useEffect, useRef, } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
} from "@mui/material";

import { gsap } from "gsap";

import { useInView } from "react-intersection-observer";
import GroupsIcon from "@mui/icons-material/Groups";
import NatureIcon from "@mui/icons-material/Nature";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import PublicIcon from "@mui/icons-material/Public";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

const WhyChooseUsHomeSection = () => {
  // const [isScrolled, setIsScrolled] = useState(false);
  const { ref: whyChooseRef, inView: whyChooseInView } = useInView({
    triggerOnce: true,
  });

  const whyChooseElements = useRef([]);

  useEffect(() => {
    if (whyChooseInView) {
      gsap.fromTo(
        whyChooseElements.current,
        { scale: 0, rotation: 180, opacity: 0 },
        {
          scale: 1,
          rotation: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.1,
          ease: "elastic.out(1, 0.8)",
        }
      );
    }
  }, [whyChooseInView]);

  return (
    <Box
      ref={whyChooseRef}
      id="why-choose"
      sx={{
        py: { xs: 5, md: 10 },
        // background: `
        //     linear-gradient(135deg, rgba(244, 197, 66, 0.05) 0%, rgba(255, 255, 255, 1) 50%, rgba(244, 197, 66, 0.05) 100%)
        //   `,
        background:'#fff',
        position: "relative",
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ textAlign: "center", mb: 12 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "3rem", md: "4rem" },
              fontWeight: 900,
              mb: 4,
              color: "#2D3A27",
              letterSpacing: "-2px",
            }}
          >
            Why Choose ScrapTrade
          </Typography>
          <Typography
            variant="h5"
            sx={{
              color: "rgba(45, 58, 39, 0.7)",
              maxWidth: "700px",
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            The Dynamic scrap trading platform for buyers and sellers worldwide.
          </Typography>
        </Box>

        <Grid container spacing={4} sx={{ mb: 8 }} justifyContent="center">
          {[
            {
              icon: <GroupsIcon sx={{ fontSize: 80, color: "#F4C542" }} />,
              title: "Trusted Network",
              description:
                "Trade with confidence in a community of verified buyers and sellers",
              gradient: "linear-gradient(135deg, #FFF9C4 0%, #FDD835 100%)",
            },
            {
              icon: <NatureIcon sx={{ fontSize: 80, color: "#4CAF50" }} />,
              title: "Sustainable Impact",
              description:
                "Support recycling and drive environmental responsibility with every trade",
              gradient: "linear-gradient(135deg, #C8E6C9 0%, #81C784 100%)",
            },
            {
              icon: <TouchAppIcon sx={{ fontSize: 80, color: "#2196F3" }} />,
              title: "User-Friendly Platform",
              description:
                "A simple, intuitive interface built for both beginners and professionals",
              gradient: "linear-gradient(135deg, #BBDEFB 0%, #64B5F6 100%)",
            },
            {
              icon: <FactCheckIcon sx={{ fontSize: 80, color: "#9C27B0" }} />,
              title: "Verified Listings",
              description:
                "All materials are checked and authenticated for accuracy and reliability",
              gradient: "linear-gradient(135deg, #E1BEE7 0%, #BA68C8 100%)",
            },
            {
              icon: <PublicIcon sx={{ fontSize: 80, color: "#FF9800" }} />,
              title: "Global Marketplace",
              description:
                "Seamlessly connect with partners across Australia and international markets",
              gradient: "linear-gradient(135deg, #FFE0B2 0%, #FFB74D 100%)",
            },
            {
              icon: (
                <NotificationsActiveIcon
                  sx={{ fontSize: 80, color: "#00BCD4" }}
                />
              ),
              title: "Real-Time Insights",
              description:
                "Access instant alerts, live pricing, and market trends to stay ahead",
              gradient: "linear-gradient(135deg, #B2EBF2 0%, #4DD0E1 100%)",
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Box
                ref={(el) => (whyChooseElements.current[index] = el)}
                sx={{
                  textAlign: "center",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    width: 120,
                    height: 120, // Reduced container size
                    borderRadius: "24px",
                    background: feature.gradient,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "auto",
                    mb: 4, // less margin below
                    position: "relative",
                    boxShadow: `0 20px 40px ${
                      index === 0
                        ? "rgba(244, 197, 66, 0.2)"
                        : index === 1
                        ? "rgba(76, 175, 80, 0.2)"
                        : "rgba(33, 150, 243, 0.2)"
                    }`,
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      inset: -4,
                      background: feature.gradient,
                      borderRadius: "28px",
                      filter: "blur(15px)",
                      opacity: 0.3,
                      zIndex: -1,
                    },
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.05) rotate(3deg)",
                    },
                  }}
                >
                  {feature.icon}
                </Box>

                <Typography
                  variant="h5"
                  sx={{
                    color: "#2D3A27",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: "1.5rem", // smaller title
                  }}
                >
                  {feature.title}
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    color: "rgba(45, 58, 39, 0.7)",
                    lineHeight: 1.5,
                    maxWidth: "320px",
                    mx: "auto",
                    fontSize: "1rem", // smaller description
                  }}
                >
                  {feature.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
    
  );
};

export default WhyChooseUsHomeSection;
